import * as React from 'react';
import styles from './index.less';
import { Checkbox, Radio, Space } from 'antd';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { CollectionManagerState, ConnectState } from '@/models/connect';
import {
  ChangeAction,
  Info_OnChange_Cover_Action,
  Info_OnChange_Labels_Action,
  Info_OnChange_TitleInput_Action,
  Info_OnClick_CancelEditTitleBtn_Action,
  Info_OnClick_EditTitleBtn_Action,
  Info_OnClick_SaveIntroductionBtn_Action,
  Info_OnClick_SaveTitleBtn_Action,
  Info_OnMount_Page_Action,
  Info_OnUnmount_Page_Action,
  Sider_OnChange_Page_Action,
  Sider_OnMount_Page_Action,
} from '@/models/collectionManager';
import { RouteComponentProps } from 'react-router';
import { Helmet } from 'react-helmet';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FSkeletonNode from '@/components/FSkeletonNode';
import * as AHooks from 'ahooks';
import FResourceLabelEditor from '@/components/FResourceLabelEditor';
import fMessage from '@/components/fMessage';
import FUploadCover from '@/components/FUploadCover';
import FCoverImage from '@/components/FCoverImage';
import FSelect2 from '@/components/FSelect2';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import { history } from '@@/core/history';
import FPrompt from '@/components/FPrompt';
import FResourceTypeInput3 from '@/components/FResourceTypeInput3';
import FIntroductionInput from '@/components/FIntroductionInput';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';

interface InfoProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  collectionManager: CollectionManagerState;
}

function Info({ dispatch, collectionManager, match }: InfoProps) {
  const [$isEditing_Introduction, set$isEditing_Introduction, get$isEditing_Introduction] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$isEditing_Setting, set$isEditing_Setting, get$isEditing_Setting] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<Sider_OnMount_Page_Action>({
      type: 'collectionManager/sider_onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });
    dispatch<Sider_OnChange_Page_Action>({
      type: 'collectionManager/sider_onChange_Page',
      payload: {
        page: 'info',
      },
    });
    dispatch<Info_OnMount_Page_Action>({
      type: 'collectionManager/info_onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });
  });

  AHooks.useUnmount(async () => {
    await dispatch<Info_OnUnmount_Page_Action>({
      type: 'collectionManager/info_onUnmount_Page',
    });
  });

  return (
    <>
      <FPrompt
        watch={
          collectionManager.info_title_IsEditing || $isEditing_Introduction || $isEditing_Setting
        }
        onOk={(locationHref) => {
          history.push(locationHref);
        }}
      />

      <Helmet>
        <title>{`合集信息 · ${
          collectionManager.info_resourceInfo?.resourceName || ''
        }  - Freelog`}</title>
      </Helmet>
      {collectionManager.info_pageState === 'loading' && (
        <div>
          <div style={{ height: 40 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={860} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 20 }}>
            <FSkeletonNode width={200} height={150} />
            <FSkeletonNode width={460} height={40} />
          </div>
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
        </div>
      )}

      {!!collectionManager.info_resourceInfo && collectionManager.info_pageState === 'loaded' && (
        <div>
          <div style={{ height: 40 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                // text={'资源授权标识'}
                text={FI18n.i18nNext.t('edit_collection_listing_authid')}
                type={'highlight'}
              />
              <FCopyToClipboard
                text={collectionManager.info_resourceInfo.resourceName}
                // title={'复制'}
                title={FI18n.i18nNext.t('edit_resource_listing_btn_copy')}
              >
                <FComponentsLib.FTextBtn type={'primary'} style={{ fontSize: 12 }}>
                  {/* 复制 */}
                  {FI18n.i18nNext.t('edit_resource_listing_btn_copy')}
                </FComponentsLib.FTextBtn>
              </FCopyToClipboard>
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              // text={'此资源在整个授权系统中的唯一标识符，一旦创建则不能更改。'}
              text={FI18n.i18nNext.t('edit_collection_listing_authid_info')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            <div className={styles.resourceTitle} style={{ justifyContent: 'space-between' }}>
              <FComponentsLib.FContentText
                text={collectionManager.info_resourceInfo.resourceName}
                type={'normal'}
              />

              <FIcons.FLock style={{ color: '#999', fontSize: 14 }} />
            </div>
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                text={
                  // 资源标题
                  FI18n.i18nNext.t('edit_collection_listing_title')
                }
                type={'highlight'}
              />

              {collectionManager.info_title_IsEditing ? (
                <Space size={10}>
                  <FComponentsLib.FTextBtn
                    type={'default'}
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      dispatch<Info_OnClick_CancelEditTitleBtn_Action>({
                        type: 'collectionManager/info_onClick_CancelEditTitleBtn',
                      });
                    }}
                  >
                    {/* 取消 */}
                    {FI18n.i18nNext.t('btn_cancel')}
                  </FComponentsLib.FTextBtn>
                  <FComponentsLib.FTextBtn
                    style={{ fontSize: 12 }}
                    disabled={
                      collectionManager.info_title_Input === '' ||
                      collectionManager.info_title_Input.length > 100
                    }
                    type={'primary'}
                    onClick={() => {
                      dispatch<Info_OnClick_SaveTitleBtn_Action>({
                        type: 'collectionManager/info_onClick_SaveEditTitleBtn',
                        payload: {
                          trigger: 'collection',
                        },
                      });
                    }}
                  >
                    {/* 保存 */}
                    {FI18n.i18nNext.t('btn_save')}
                  </FComponentsLib.FTextBtn>
                </Space>
              ) : (
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  style={{ fontSize: 12 }}
                  onClick={() => {
                    dispatch<Info_OnClick_EditTitleBtn_Action>({
                      type: 'collectionManager/info_onClick_EditTitleBtn',
                    });
                  }}
                >
                  {/* 编辑 */}
                  {FI18n.i18nNext.t('edit_resource_listing_btn_edit')}
                </FComponentsLib.FTextBtn>
              )}
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              // text={'标题直接影响商品的搜索曝光机会，建议在标题中加入品牌/内容主旨，例如，《大明风华：明朝人的城市生活》；标题长度不超过100个字符。'}
              text={FI18n.i18nNext.t('edit_collection_listing_title_info')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            {collectionManager.info_title_IsEditing && (
              <>
                <FInput_PinyinSafeTextCounter
                  value={collectionManager.info_title_Input || ''}
                  lengthLimit={100}
                  style={{ width: '100%' }}
                  placeholder={FI18n.i18nNext.t('cqr_input_title_hint')}
                  onChangeValue={(v) => {
                    dispatch<Info_OnChange_TitleInput_Action>({
                      type: 'collectionManager/info_onChange_TitleInput',
                      payload: {
                        value: v,
                      },
                    });
                  }}
                  hasError={collectionManager.info_title_Error !== ''}
                />
                {collectionManager.info_title_Error !== '' && (
                  <>
                    <div style={{ height: 5 }} />
                    <div style={{ color: '#EE4040' }}>{collectionManager.info_title_Error}</div>
                  </>
                )}
              </>
            )}

            {!collectionManager.info_title_IsEditing && (
              <div className={styles.resourceTitle}>
                <FComponentsLib.FContentText
                  text={
                    collectionManager.info_resourceInfo.resourceTitle ||
                    collectionManager.info_resourceInfo.resourceName.split('/')[1] ||
                    ''
                  }
                  type={'normal'}
                />
              </div>
            )}
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('rqr_input_resouce_image')}
              type={'highlight'}
            />
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('rqr_input_resouce_image_help')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            <FUploadCover
              onUploadSuccess={(url) => {
                dispatch<Info_OnChange_Cover_Action>({
                  type: 'collectionManager/info_onChange_Cover',
                  payload: {
                    value: url,
                    trigger: 'collection',
                  },
                });
              }}
              onError={(err) => {
                fMessage(err, 'error');
              }}
            >
              {collectionManager.info_resourceInfo.coverImages.length === 0 && (
                <a className={styles.FUploadImageChildren}>
                  <FIcons.FCloudUpload />
                  <span>{FI18n.i18nNext.t('upload_image')}</span>
                </a>
              )}

              {collectionManager.info_resourceInfo.coverImages.length > 0 && (
                <div className={styles.cover}>
                  <FCoverImage
                    src={collectionManager.info_resourceInfo.coverImages[0]}
                    width={200}
                    style={{ borderRadius: 4 }}
                  />
                  <div className={styles.coverEdit}>
                    <FIcons.FEdit style={{ fontSize: 32 }} />
                    <div style={{ height: 10 }} />
                    <div>{FI18n.i18nNext.t('btn_edit_cover')}</div>
                  </div>
                </div>
              )}
            </FUploadCover>
          </div>

          <div style={{ height: 5 }} />

          <FIntroductionInput
            value={collectionManager.info_introduction_EditorText}
            title={FI18n.i18nNext.t('resource_short_description')}
            tip={FI18n.i18nNext.t('listing_description_info')}
            btnText={FI18n.i18nNext.t('listing_description_btn')}
            // tip={}
            onOK={async (value) => {
              await dispatch<ChangeAction>({
                type: 'collectionManager/change',
                payload: {
                  info_introduction_EditorText: value,
                },
              });
              await dispatch<Info_OnClick_SaveIntroductionBtn_Action>({
                type: 'collectionManager/info_onClick_SaveIntroductionBtn',
              });
            }}
            onEditingChange={(isEditing) => {
              set$isEditing_Introduction(isEditing);
            }}
          />

          <div style={{ height: 5 }} />

          <UpdateStatesSettingBlock
            username={collectionManager.info_username}
            resourceID={collectionManager.info_resourceID}
            value={collectionManager.info_updateSetting}
            onSaved={(value) => {
              dispatch<ChangeAction>({
                type: 'collectionManager/change',
                payload: {
                  info_updateSetting: value,
                },
              });
            }}
            onEditingChange={(isEditing) => {
              set$isEditing_Setting(isEditing);
            }}
          />

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('resource_tag')}
              type={'highlight'}
            />
            <div style={{ height: 20 }} />

            <FResourceLabelEditor
              value={collectionManager.info_resourceInfo.tags}
              resourceTypeCode={collectionManager.info_resourceInfo.resourceTypeCode}
              onChange={(value) => {
                dispatch<Info_OnChange_Labels_Action>({
                  type: 'collectionManager/info_onChange_Labels',
                  payload: {
                    value: value,
                  },
                });
              }}
            />
          </div>

          <div style={{ height: 100 }} />
        </div>
      )}
    </>
  );
}

export default connect(({ collectionManager }: ConnectState) => ({
  collectionManager: collectionManager,
}))(Info);

interface FResourceTypeInputBlockProps {
  value: string;
  disabled?: boolean;

  onChange?(value: string): void;
}

export function FResourceTypeInputBlock({
  value,
  onChange,
  disabled = false,
}: FResourceTypeInputBlockProps) {
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<null | {
    value: string;
    labels: string[];
    customInput?: string;
  }>(null);

  AHooks.useDebounceEffect(
    () => {
      if (value === '') {
        set$value(null);
        return;
      }
      if (value === $value?.value) {
        return;
      }
      handleValue();
    },
    [value],
    {
      wait: 0,
    },
  );

  async function handleValue() {
    const {
      data,
    }: {
      data: {
        parentInfo: {
          parentChain: {
            code: string;
            name: string;
          }[];
        };
      };
    } = await FServiceAPI.ResourceType.getInfoByCode({
      code: value,
    });
    // console.log(data, 'sidojflksdjlkfjldskjfksdjflskdjflkjlkj');
    set$value({
      value: value,
      labels: data.parentInfo.parentChain
        .map((pc) => {
          return pc.name;
        })
        .reverse(),
    });
  }

  return (
    <div style={{ width: 420 }}>
      <FResourceTypeInput3
        width={420}
        disabled={disabled}
        // disabled={true}
        onlySelect={true}
        value={$value}
        onChange={async (value) => {
          set$value(value);
          onChange && onChange(value?.value || '');
        }}
        showAddNewType={true}
      />
    </div>
  );
}

interface UpdateStatesSettingBlockProps {
  username: string;
  resourceID: string;
  value: {
    isFinish: boolean;
    automatic: boolean;
    conditionType: 'every' | 'some';
    conditions: {
      key: 'resourceTitle' | 'resourceTypeCode' | 'authIdentity';
      limitOperatorType:
        | 'INCLUDES'
        | 'NOT_INCLUDES'
        | 'STARTS_WITH'
        | 'ENDS_WITH'
        | 'EQUAL'
        | 'NOT_EQUAL';
      value: string;
      valueError: string;
    }[];
  };

  onChange?(value: UpdateStatesSettingBlockProps['value']): void;

  onSaved?(value: UpdateStatesSettingBlockProps['value']): void;

  onEditingChange?(isEditing: boolean): void;
}

export function UpdateStatesSettingBlock({
  username,
  resourceID,
  value,
  onChange,
  onSaved,
  onEditingChange,
}: UpdateStatesSettingBlockProps) {
  const [$setting, set$setting, get$setting] =
    FUtil.Hook.useGetState<UpdateStatesSettingBlockProps['value']>(value);
  const [$isEdit, set$isEdit, get$isEdit] = FUtil.Hook.useGetState<boolean>(!onSaved);

  function change(v: UpdateStatesSettingBlockProps['value']) {
    if (!get$isEdit()) {
      return;
    }

    set$setting(v);
    onChange?.(v);
  }

  return (
    <div className={styles.block}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <FComponentsLib.FContentText
          // text={'更新状态'}
          text={FI18n.i18nNext.t('cqr_itemmgmt_updatestates')}
          type={'highlight'}
        />

        {onSaved && (
          <Space size={10}>
            {!$isEdit && (
              <FComponentsLib.FTextBtn
                style={{ fontSize: 12 }}
                onClick={() => {
                  set$isEdit(true);
                  onEditingChange?.(true);
                  set$setting(value);
                }}
              >
                {FI18n.i18nNext.t('edit')}
              </FComponentsLib.FTextBtn>
            )}
            {$isEdit && (
              <>
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 12 }}
                  type='default'
                  onClick={() => {
                    set$isEdit(false);
                    onEditingChange?.(false);
                    set$setting(value);
                  }}
                >
                  {FI18n.i18nNext.t('cancel')}
                </FComponentsLib.FTextBtn>
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 12 }}
                  onClick={async () => {
                    const { ret, errCode, msg, data } = await FServiceAPI.Resource.setCollectRules({
                      resourceId: resourceID,
                      serializeStatus: get$setting().isFinish ? 1 : 0,
                      status: get$setting().automatic ? 1 : 0,
                      conditionType: get$setting().conditionType === 'every' ? 1 : 2,
                      filterConditions: get$setting().conditions.map((c) => {
                        return {
                          key: c.key,
                          limitOperatorType: c.limitOperatorType,
                          value:
                            c.limitOperatorType === 'STARTS_WITH'
                              ? username + '/' + c.value
                              : c.value,
                        };
                      }),
                    });

                    if (ret !== 0 || errCode !== 0) {
                      fMessage(msg, 'error');
                      return;
                    }

                    onSaved(get$setting());
                    set$isEdit(false);
                    onEditingChange?.(false);
                  }}
                  disabled={$setting.conditions.some((c) => {
                    return c.value === '' || c.valueError !== '';
                  })}
                >
                  {FI18n.i18nNext.t('save')}
                </FComponentsLib.FTextBtn>
              </>
            )}
          </Space>
        )}
      </div>
      <div style={{ height: 20 }} />

      {!$isEdit && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            {!$setting.isFinish ? (
              <>
                <FComponentsLib.FContentText text={'持续更新'} type={'normal'} />
                <FComponentsLib.FContentText
                  text={'未来将持续添加新的单品到此合集中。'}
                  type={'additional2'}
                />
              </>
            ) : (
              <>
                <FComponentsLib.FContentText text={'更新完毕'} type={'normal'} />
                <FComponentsLib.FContentText
                  text={'未来将不会持续添加新的单品到此合集中。'}
                  type={'additional2'}
                />
              </>
            )}
          </div>

          {!$setting.isFinish && (
            <>
              <div style={{ height: 20 }} />
              {$setting.automatic && (
                <div
                  style={{
                    backgroundColor: 'rgba(0,0,0,0.03)',
                    borderRadius: 6,
                    padding: 20,
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FComponentsLib.FContentText
                      text={
                        // '自动收入单品'
                        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_title')
                      }
                      type={'normal'}
                    />
                    <div style={{ width: 20 }} />

                    <div className={styles.learnMore}>
                      {FI18n.i18nNext.tJSXElement('cqr_itemmgmt_autoadd_info')}
                    </div>
                    {/* <FComponentsLib.FContentText
                      text={'在满足匹配条件时，未来新发行的独立资源将作为单品添加到此合集中。'}
                      type={'additional2'}
                    />
                    <div style={{ width: 10 }} />
                    <FComponentsLib.FTextBtn type={'primary'} style={{ fontSize: 12 }}>
                      了解更多
                    </FComponentsLib.FTextBtn> */}
                    {/*cqr_itemmgmt_autoadd_info*/}
                  </div>

                  <div style={{ height: 20 }} />
                  {$setting.conditionType === 'every' ? (
                    <div style={{ color: '#222' }}>
                      {/* 满足以下所有条件 */}
                      {FI18n.i18nNext.t('cqr_itemmgmt_autoadd_matchall')}
                    </div>
                  ) : (
                    <div style={{ color: '#222' }}>
                      {/* 满足以下任意条件 */}
                      {FI18n.i18nNext.t('cqr_itemmgmt_autoadd_matchany')}
                    </div>
                  )}
                  <div style={{ height: 20 }} />

                  <Conditions
                    disabled={true}
                    username={username}
                    showDelete={false}
                    value={$setting.conditions}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}

      {$isEdit && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Radio
              style={{ margin: 0 }}
              checked={$setting.isFinish}
              onClick={async () => {
                change({
                  ...get$setting(),
                  isFinish: true,
                  // automatic: false,
                });
              }}
            />
            <div style={{ width: 10 }} />
            <div style={{ color: $setting.isFinish ? '#2784FF' : '#222' }}>
              {/*更新完毕*/}
              {FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')}
            </div>
            <div style={{ width: 30 }} />
            <FComponentsLib.FContentText
              // text={'截至此次发布，所有单品已经添加到此合集当中。'}
              text={FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed_info')}
              type={'additional2'}
            />
          </div>
          <div style={{ height: 15 }} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Radio
              style={{ margin: 0 }}
              checked={!$setting.isFinish}
              onClick={async () => {
                change({
                  ...$setting,
                  isFinish: false,
                });
              }}
            />
            <div style={{ width: 10 }} />
            <div style={{ color: !$setting.isFinish ? '#2784FF' : '#222' }}>
              {/*持续更新*/}
              {FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')}
            </div>
            <div style={{ width: 30 }} />
            <FComponentsLib.FContentText
              // text={'未来将持续添加新的单品到此合集中。'}
              text={FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing_info')}
              type={'additional2'}
            />
          </div>

          {!$setting.isFinish && (
            <>
              <div style={{ height: 20 }} />
              <div style={{ backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 6 }}>
                <div style={{ padding: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={$setting.automatic}
                      style={{ margin: 0 }}
                      onChange={async (e) => {
                        if (e.target.checked) {
                          change({
                            ...$setting,
                            automatic: e.target.checked,
                            // conditionType: 'every',
                            conditions:
                              $setting.conditions.length === 0
                                ? [
                                    {
                                      key: 'resourceTitle',
                                      limitOperatorType: 'INCLUDES',
                                      value: '',
                                      valueError: '',
                                    },
                                  ]
                                : $setting.conditions,
                          });
                        } else {
                          // const result = await fPromiseModalConfirm({
                          //   title: '提示',
                          //   description: '不再自动收入单品，将会清空已填写的收入条',
                          // });

                          // if (result) {
                          change({
                            ...$setting,
                            automatic: e.target.checked,
                            // conditionType: 'every',
                            // conditions: [],
                          });
                          // }
                        }
                      }}
                    />
                    <div style={{ width: 10 }} />
                    <FComponentsLib.FContentText
                      text={
                        // '自动收入单品'
                        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_title')
                      }
                      type={'normal'}
                    />
                    <div style={{ width: 30 }} />
                    {/*<FComponentsLib.FContentText*/}
                    {/*  text={'在满足匹配条件时，未来新发行的独立资源将作为单品添加到此合集中。'}*/}
                    {/*  type={'additional2'}*/}
                    {/*/>*/}
                    {/*<div style={{ width: 10 }} />*/}
                    {/*<FComponentsLib.FTextBtn*/}
                    {/*  type={'primary'}*/}
                    {/*  style={{ fontSize: 12 }}*/}
                    {/*>了解更多</FComponentsLib.FTextBtn>*/}
                    <div className={styles.learnMore}>
                      {FI18n.i18nNext.tJSXElement('cqr_itemmgmt_autoadd_info')}
                    </div>
                  </div>
                  {$setting.automatic && (
                    <>
                      <div style={{ height: 20 }} />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Radio
                          style={{ margin: 0 }}
                          checked={$setting.conditionType === 'every'}
                          onClick={async () => {
                            change({
                              ...$setting,
                              conditionType: 'every',
                            });
                          }}
                        />
                        <div style={{ width: 10 }} />
                        <div style={{ color: '#222' }}>
                          {/* 满足以下所有条件 */}
                          {FI18n.i18nNext.t('cqr_itemmgmt_autoadd_matchall')}
                        </div>
                        <div style={{ width: 30 }} />
                        <Radio
                          style={{ margin: 0 }}
                          checked={$setting.conditionType === 'some'}
                          onClick={async () => {
                            change({
                              ...$setting,
                              conditionType: 'some',
                            });
                          }}
                        />
                        <div style={{ width: 10 }} />
                        <div style={{ color: '#222' }}>
                          {/* 满足以下任意条件 */}
                          {FI18n.i18nNext.t('cqr_itemmgmt_autoadd_matchany')}
                        </div>
                      </div>
                      <div style={{ height: 20 }} />

                      <Conditions
                        username={username}
                        showDelete={$setting.conditions.length > 1 && $isEdit}
                        value={$setting.conditions}
                        onChange={(value) => {
                          change({
                            ...$setting,
                            conditions: value,
                          });
                        }}
                      />

                      <div style={{ height: 20 }} />
                      <Space
                        size={5}
                        onClick={async () => {
                          change({
                            ...$setting,
                            conditions: [
                              ...$setting.conditions,
                              {
                                key: 'resourceTitle',
                                limitOperatorType: 'INCLUDES',
                                value: '',
                                valueError: '',
                              },
                            ],
                          });
                        }}
                      >
                        <FComponentsLib.FTextBtn>
                          <FIcons.FAdd style={{ fontSize: 14 }} />
                        </FComponentsLib.FTextBtn>
                        <FComponentsLib.FTextBtn style={{ fontSize: 12 }}>
                          {/* 添加条件 */}
                          {FI18n.i18nNext.t('cqr_itemmgmt_autoadd_btn_addcondition')}
                        </FComponentsLib.FTextBtn>
                      </Space>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

interface ConditionsProps {
  username: string;
  value: UpdateStatesSettingBlockProps['value']['conditions'];
  showDelete?: boolean;
  disabled?: boolean;

  onChange?(value: ConditionsProps['value']): void;
}

function Conditions({
  username,
  value,
  showDelete = false,
  disabled = false,
  onChange,
}: ConditionsProps) {
  const [$field_Options, set$field_Options, get$field_Options] = FUtil.Hook.useGetState<
    {
      value: 'resourceTitle' | 'authIdentity' | 'resourceTypeCode';
      label: string;
    }[]
  >([
    {
      value: 'resourceTitle',
      label:
        // '资源标题'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_resourcetitle'),
    },
    {
      value: 'authIdentity',
      label:
        // '资源授权标识',
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_resourceauthid'),
    },
    {
      value: 'resourceTypeCode',
      label:
        // '资源类型'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_resourcetype'),
    },
  ]);

  const [$term_Options, set$term_Options, get$term_Options] = FUtil.Hook.useGetState<
    {
      value: 'INCLUDES' | 'NOT_INCLUDES' | 'STARTS_WITH' | 'ENDS_WITH' | 'EQUAL' | 'NOT_EQUAL';
      label: string;
    }[]
  >([
    {
      value: 'INCLUDES',
      label:
        // '包含'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_contains'),
    },
    {
      value: 'NOT_INCLUDES',
      label:
        // '不包含'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_notcontains'),
    },
    {
      value: 'STARTS_WITH',
      label:
        // '开头包含'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_startswith'),
    },
    {
      value: 'ENDS_WITH',
      label:
        // '结尾包含',
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_endswith'),
    },
    {
      value: 'EQUAL',
      label:
        // '等于'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_equalto'),
    },
    {
      value: 'NOT_EQUAL',
      label:
        // '不等于'
        FI18n.i18nNext.t('cqr_itemmgmt_autoadd_notequalto'),
    },
  ]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'stretch',
        gap: 20,
      }}
    >
      {value.map((c, ci, ca) => {
        return (
          <div key={ci}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FSelect2
                disabled={disabled}
                style={{ width: 170 }}
                value={c.key}
                options={$field_Options}
                onChange={async (v) => {
                  onChange?.(
                    value.map((condition, conditionIndex) => {
                      if (ci !== conditionIndex) {
                        return condition;
                      }
                      return {
                        ...condition,
                        key: v,
                        limitOperatorType: v === 'resourceTypeCode' ? 'EQUAL' : 'INCLUDES',
                        value: '',
                        valueError: '',
                      };
                    }),
                  );
                }}
              />
              <FSelect2
                disabled={disabled}
                style={{ width: 170 }}
                value={c.limitOperatorType}
                options={$term_Options.filter((v) => {
                  if (c.key === 'resourceTitle' || c.key === 'authIdentity') {
                    return !(v.value === 'EQUAL' || v.value === 'NOT_EQUAL');
                  }
                  return v.value === 'EQUAL';
                })}
                onChange={async (v) => {
                  onChange?.(
                    value.map((condition, conditionIndex) => {
                      if (ci !== conditionIndex) {
                        return condition;
                      }
                      return {
                        ...condition,
                        limitOperatorType: v,
                      };
                    }),
                  );
                }}
              />
              {c.key === 'resourceTitle' && (
                <FInput_PinyinSafeTextCounter
                  disabled={disabled}
                  hasError={c.valueError !== ''}
                  style={{ width: 420 }}
                  value={c.value}
                  lengthLimit={100}
                  onChangeValue={(v) => {
                    onChange?.(
                      value.map((condition, conditionIndex) => {
                        if (ci !== conditionIndex) {
                          return condition;
                        }
                        return {
                          ...condition,
                          value: v,
                          valueError:
                            v === ''
                              ? // '不能为空'
                                FI18n.i18nNext.t('cqr_itemmgmt_autoadd_matchvalue_required', {
                                  matchfield:
                                    $field_Options.find((v) => {
                                      return v.value === c.key;
                                    })?.label || '',
                                  term:
                                    $term_Options.find((v) => {
                                      return v.value === c.limitOperatorType;
                                    })?.label || '',
                                })
                              : '',
                        };
                      }),
                    );
                  }}
                />
              )}

              {c.key === 'authIdentity' && (
                // <Input
                <FInput_PinyinSafeTextCounter
                  disabled={disabled}
                  style={{ width: 420, height: 38 }}
                  value={c.value}
                  prefix={
                    c.limitOperatorType === 'STARTS_WITH' ? <span>{username} /</span> : undefined
                  }
                  lengthLimit={60}
                  onChangeValue={async (v) => {
                    onChange?.(
                      value.map((condition, conditionIndex) => {
                        if (ci !== conditionIndex) {
                          return condition;
                        }
                        return {
                          ...condition,
                          value: v,
                          valueError:
                            v === ''
                              ? // '不能为空'
                                FI18n.i18nNext.t('cqr_itemmgmt_autoadd_matchvalue_required', {
                                  matchfield:
                                    $field_Options.find((v) => {
                                      return v.value === c.key;
                                    })?.label || '',
                                  term:
                                    $term_Options.find((v) => {
                                      return v.value === c.limitOperatorType;
                                    })?.label || '',
                                })
                              : '',
                        };
                      }),
                    );
                  }}
                  hasError={c.valueError !== ''}
                />
              )}

              {c.key === 'resourceTypeCode' && (
                <FResourceTypeInputBlock
                  disabled={disabled}
                  value={c.value}
                  // value={'RT003004004'}
                  onChange={async (v) => {
                    onChange?.(
                      value.map((condition, conditionIndex) => {
                        if (ci !== conditionIndex) {
                          return condition;
                        }
                        return {
                          ...condition,
                          value: v,
                          valueError: v === '' ? '不能为空' : '',
                        };
                      }),
                    );
                    // change({
                    //   ...$setting,
                    //   conditions: ,
                    // });
                  }}
                />
              )}

              {
                // ca.length > 1 && $isEdit
                showDelete ? (
                  <FComponentsLib.FTextBtn
                    // disabled={}
                    type={'danger'}
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      onChange?.(
                        value.filter((condition, conditionIndex) => {
                          return conditionIndex !== ci;
                        }),
                      );
                      // change({
                      //   ...$setting,
                      //   conditions: ,
                      // });
                    }}
                  >
                    <FIcons.FDelete style={{ fontSize: 16 }} />
                  </FComponentsLib.FTextBtn>
                ) : (
                  <div style={{ width: 16 }} />
                )
              }
            </div>
            {c.valueError && (
              <div style={{ color: 'red', fontSize: 12, padding: '5px 0 0 380px' }}>
                {c.valueError}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
